import {
  delData,
  getData,
  patchData,
  postData,
  putData,
} from '../../../shared/api/core';

// ─── Countries ──────────────────────────────────────────────────────────────────

export const addCountry = (data) => postData(`/master-data/countries`, data);

export const updateCountry = (countryCode, data) =>
  putData(`/master-data/countries/${countryCode}`, data);

export const deleteCountry = (countryCode) =>
  delData(`/master-data/countries/${countryCode}`);

// ─── Ports ───────────────────────────────────────────────────────────────────────

export const addPort = (countryCode, data) =>
  postData(`/master-data/countries/${countryCode}/ports`, data);

export const updatePort = (countryCode, unLocode, data) =>
  putData(`/master-data/countries/${countryCode}/ports/${unLocode}`, data);

export const deletePort = (unLocode) =>
  delData(`/master-data/ports/${unLocode}`);

// ─── Unloading Points ────────────────────────────────────────────────────────────

export const getUnloadingPoints = () =>
  getData(`/master-data/unloading-points`);

export const addUnloadingPoint = (unLocode, data) =>
  postData(`/master-data/ports/${unLocode}/unloading-points`, data);

export const deleteUnloadingPoint = (unloadingCode) =>
  delData(`/master-data/unloading-points/${unloadingCode}`);

// ─── Markets ─────────────────────────────────────────────────────────────────────

export const addMarket = (data) => postData(`/master-data/market`, data);

export const updateMarket = (id, data) =>
  putData(`/master-data/market/${id}`, data);

export const deleteMarket = (id) => delData(`/master-data/market/${id}`);

// ─── Carrier-Supplier Mappings ───────────────────────────────────────────────────

export const getCarrierSupplierMap = () =>
  getData(`/master-data/carrier-mappings`);

export const addCarrierSupplierMap = (data) =>
  postData(`/master-data/carrier-mappings`, data);

export const updateCarrierSupplierMap = (id, data) =>
  putData(`/master-data/carrier-mappings/${id}`, data);

export const deleteCarrierSupplierMap = (id) =>
  delData(`/master-data/carrier-mappings/${id}`);

// ─── Holds ───────────────────────────────────────────────────────────────────────

export const getHolds = () => getData(`/master-data/hold`);

export const addHold = (data) => postData(`/master-data/hold`, data);

export const updateHold = (id, data) =>
  putData(`/master-data/hold/${id}`, data);

export const deleteHold = (id) => delData(`/master-data/hold/${id}`);

// ─── LP Suppliers (CRUD) ─────────────────────────────────────────────────────────

export const addLpSupplier = (data) =>
  postData(`/master-data/lp-suppliers`, data);

export const updateLpSupplier = (supplierNo, data) =>
  putData(`/master-data/lp-suppliers/${supplierNo}`, data);

export const deleteLpSupplier = (supplierNo) =>
  delData(`/master-data/lp-suppliers/${supplierNo}`);

// ─── API Keys ────────────────────────────────────────────────────────────────────

export const getApiKeys = () => getData(`/master-data/api-keys`);

export const createApiKey = (data) => postData(`/master-data/api-keys`, data);

export const revokeApiKey = (keyId) =>
  putData(`/master-data/api-keys/${keyId}/revoke`, {});

export const rotateApiKey = (keyId, data) =>
  postData(`/master-data/api-keys/${keyId}/rotate`, data || {});

export const getApiScopes = () => getData(`/master-data/api-keys/scopes`);

export const updateApiKeyStagingMode = (keyId, stagingMode) =>
  patchData(`/master-data/api-keys/${keyId}/staging-mode`, { stagingMode });
